export const document = {
  add_btn: 'Добавить документ',
  field: {
    document: 'Документ'
  },
  form: {
    title: 'Загрузить документы',
    text:
      'Загрузите цветную скан-копию второго разворота паспорта и страницы с пропиской. <br>' +
      'Вы можете загрузить файлы с расширениями: .jpg, .jpeg, .png, .pdf. <br>' +
      'Максимальный размер загружаемого файла 10 МБ. <br>' +
      'Вы можете загрузить не более пяти файлов одновременно. <br>' +
      'Проверка документов занимает 1-3 рабочих дней. ',
    save_file_btn: 'Сохранить файлы',
    selected_file_btn: 'Выбрать файлы'
  },
  error: {
    max_size: '{filename} превышает максимальный размер загружаемого файла'
  },
  status: {
    new: 'На модерации',
    approved: 'Одобрено',
    rejected: 'Отклонено'
  }
};
